<template>
  <div class="content">
    <div class="holder container">
      <swiper :options="swiperOption" ref="swiperThemeList">
        <swiper-slide
          v-for="(item, index) in typeLists"
          :key="index"
          :class="{'active' : typeActive === item.type}"
          @click.native="handleChangeTab(item)"
        >
          <div style="display:block">{{ item.type }}</div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev prev-category"></div>
      <div :class="[{'button-disabled' : isSliderEnd},'swiper-button-next', 'next-category']"></div>

      <div class="content-img tab-content lazy-loading">
        <div
          class="container row list-template m-auto lazy-loading__item"
          v-for="typeList in typeLists"
          :key="typeList.type"
          :id="`menu${typeList.type}`"
          :style="{display: typeActive === typeList.type ?  'flex': 'none'}"
        >
          <div
            class="col-10 col-md-6 col-xl-3 mb-4 item-template"
            v-for="template in typeList.templates"
            :key="template.templateId"
          >
            <div class="content-img-item" @click="confirmSelectTemplate(template)">
              <p class="template-id">{{ template.templateId }}</p>
              <label
                class="template-status"
                v-if="template.templateStatus == $t('front_end.a010.private_type')"
              >{{$t('front_end.a010.private_type')}}</label>
              <img :src="template.thumbnailUrl" :alt="template.category" />
              <p class="template-name">{{ template.category }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .holder -->
    <router-view></router-view>
  </div>
</template>
<script>
import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters } from "vuex";
export default {
  name: "A010",
  created() {
    this.getTemplates();
  },
  data() {
    return {
      typeLists: [],
      swiper: null,
      typeActive: "",
      isSliderEnd: false,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 25,
        navigation: {
          nextEl: ".next-category",
          prevEl: ".prev-category"
        },
        breakpoints: {
          767: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 4.5,
            spaceBetween: 15
          },
          320: {
            slidesPerView: 2.5,
            spaceBetween: 10
          }
        }
      },
      isShopMode: false,
      shopId: "",
      definision: "",
      category: "",
      //template select
      templateSelect: {},
      templateId: null,
      listTemplateId: [],
      listDataImages: []
    };
  },
  computed: {
    ...mapGetters(["shopMode", "userData"])
  },
  methods: {
    async getTemplates() {
      this.definision = this.userData.selected.definision;
      this.category = this.userData.selected.category;
      this.isShopMode = this.shopMode.shopName ? true : false;
      if (this.isShopMode) {
        this.shopId = this.shopMode.shopId;
      }
      let result = await api.post(apiEndpoints.getUsrTemplateList, {
        shopId: this.shopId,
        definision: this.definision,
        category: this.category
      });

      if (result && result.data) {
        let arrayTemplate = result.data.templateDetails;
        // group template by type
        let groups = {};
        for (let i = 0; i < arrayTemplate.length; i++) {
          let typeName = arrayTemplate[i].type;
          if (!groups[typeName]) {
            groups[typeName] = [];
          }
          groups[typeName].push(arrayTemplate[i]);
        }
        arrayTemplate = [];
        for (var typeName in groups) {
          arrayTemplate.push({ type: typeName, templates: groups[typeName] });
        }
        this.typeLists = arrayTemplate;
        if (this.userData.templates.templateActive) {
          this.typeActive = this.userData.templates.templateActive.type;
          this.listDataImages = this.userData.templates.listTemplateSelect;
        } else {
          this.typeActive = this.typeLists[0].type;
          this.listDataImages = this.typeLists[0].templates;
          // set list template seleted by type
          this.$store.commit("userData/SET_TEMPLATES", {
            listTemplateSelect: this.typeLists[0].templates
          });
        }
      }
    },
    handleChangeTab(typeTemplate) {
      this.typeActive = typeTemplate.type;
      let dataTypeTemplate = typeTemplate;
      // template select
      this.listTemplateId = [];
      this.listDataImages = [];
      dataTypeTemplate.templates.map(value => {
        this.listTemplateId.push(value.templateId);
        this.listDataImages.push(value);
      });

      // set list template seleted by type
      this.$store.commit("userData/SET_TEMPLATES", {
        listTemplateSelect: dataTypeTemplate.templates
      });
    },
    confirmSelectTemplate(template) {
      this.templateSelect = template;
      // set templateId selected
      this.$store.commit("userData/SET_TEMPLATES", {
        templateActive: this.templateSelect
      });
      this.$router.push({ name: "a015" });
    }
  }
};
</script>

<style>
.swiper-button-prev:after,
.swiper-button-next:after {
  display: none;
}
</style>

<style scoped src="../../assets/css/themeList/themeList.css"></style>
